module.exports = __webpack_public_path__ + "img/yin.15b306a3.png";